/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePatientDto } from '../../models/create-patient-dto';
import { Patient } from '../../models/patient';

export interface CreateOneBaseMyPatientControllerPatient$Params {
      body: CreatePatientDto
}

export function createOneBaseMyPatientControllerPatient(http: HttpClient, rootUrl: string, params: CreateOneBaseMyPatientControllerPatient$Params, context?: HttpContext): Observable<StrictHttpResponse<Patient>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMyPatientControllerPatient.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Patient>;
    })
  );
}

createOneBaseMyPatientControllerPatient.PATH = '/api/my-patients';
